<template lang="pug">
  div(class="vkb-nak-chart")
    highcharts(:options="chartOptions" ref="highcharts")
</template>

<script>
import { formatPercent } from '@/modules/utils';
import moment from 'moment';

export default {
  name: 'noa-chart',

  props: {
    data: {
      type: Array,
      default: () => []
    },
    height: {
      type: [ Number, String ],
      default: 400
    },
    app: {
      type: String,
      default: 'vkb'
    },
    min: {
      type: [Number, null],
      default: null
    },
    max: {
      type: [Number, null],
      default: null
    }
  },

  computed: {
    chartOptions() {
      let colors = {
        vkb: ['#0d57a6', 'rgba(13, 87, 166, 0.1)', 'rgba(13, 87, 166, 0.5)'],
        fsoel: ['#DE2920', 'rgba(221, 41, 32, 0.1)', 'rgba(221, 41, 32, 0.5)'],
        slv: ['#004F9F', 'rgba(0, 79, 159, 0.1)', 'rgba(0, 79, 159, 0.5)'],
      };

      let min = this.min;
      let max = this.max;

      if (this.min === null || this.max === null) {
        this.data.forEach(d => {
          if (d[1] === null) {
            return;
          }

          if (min === null || min > d[1]) {
            min = d[1];
          }

          if (max === null || max < d[1]) {
            max = d[1];
          }
        });

        if (min === null) {
          min = 5;
        }

        if (max === null) {
          max = 5;
        }

        min = min < 5 ? min : min - 5;
        max = max + 5;
      }

      let minTickInterval = this.data.length > 10
        ? 5
        : 1;

      return {
        // chart: {
        //   zoomType: 'x'
        // },
        title: {
          text: ''
        },
        credits: {
          enabled: false
        },
        xAxis: {
          type: 'datetime',
          labels: {
            formatter: function() {
              return moment(this.value, 'x').format('DD.MM.YYYY');
            }
          },
          showEmpty: false,
          minTickInterval: 24 * 60 * 60 * 1000 * minTickInterval, // 5 days
          showFirstLabel: true
        },
        yAxis: {
          title: {
            text: ''
          },
          labels: {
            formatter: function() {
              return `${ formatPercent(this.value, 2) } EURO`;
            }
          },
          min,
          max
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          area: {
            connectNulls: true,
            fillColor: {
              linearGradient: {
                x1: 0,
                y1: 0,
                x2: 0,
                y2: 1
              },
              stops: [
                [ 0, colors[this.app][0] ],
                [ 1, colors[this.app][1] ]
              ]
            },
            marker: {
              radius: 2,
              fillColor: colors[this.app][0]
            },
            lineColor: colors[this.app][2],
            lineWidth: 1,
            states: {
              hover: {
                lineWidth: 1
              }
            },
          }
        },
        tooltip: {
          borderColor: colors[this.app][2],
          headerFormat: '',
          pointFormatter: function() {
            let header = `<b>Datum: </b>${ moment(this.x).format('DD.MM.YYYY') }`;
            return `${ header }<br><b>Kurswert: </b>${ formatPercent(this.y, 2) } €`;
          }
        },
        series: [{
          type: 'area',
          name: 'Kurswert',
          data: this.data
        }]
      };
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/apps/index_app/chart.vue